var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp tag-item-comp",class:{
    'is-small': _vm.isSmall,
    'is-plain': _vm.isPlain,
    'is-primary': _vm.isPrimary,
    'is-round': _vm.isRound,
    'disabled': _vm.disabled,
    'auto-width': _vm.autoWidth
  },on:{"click":function () {
      _vm.click(_vm.id);
    }}},[_c('span',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }